import { withTranslation } from "react-i18next";
import TripItinerary from './TripItinerary';

export default withTranslation()(TripItinerary);